import { set} from '@/utils/vuex'

export default {
  setPipefishUsers: set('pipefishUsers'),
  setPractices: set('practices'),
  setActivities: set('activities'),
  setProjects: set('projects'),
  setStatements: set('statements'),
  setSummary: set('summary'),
  setSelectedDates: set('selectedDates')
}